let route = {
    path: '/modules/wms/manage',
    name: 'wms-manage',
    component: () => import('@/modules/wms-manage/index.vue'),
    children: [
        {
            path: 'supplier',
            name: 'Wms-Manage-Supplier',
            component: () => import('@/modules/wms-manage/supplier/index.vue'),
            meta: {
                pageTitle: '供应商管理',
            }
        },
        {
            path: 'supplier/edit',
            name: 'Wms-Manage-Supplier-Edit',
            component: () => import('@/modules/wms-manage/supplier/edit.vue'),
            meta: {
                parent: '/modules/wms/manage/supplier',
            }
        },
        {
            path: 'warehouse',
            name: 'Wms-Warehouse-Stock',
            component: () => import('@/modules/wms-manage/warehouse/index.vue'),
            meta: {
                pageTitle: '仓库管理',
            }
        },
        {
            path: 'warehouse/edit',
            name: 'Wms-Manage-Warehouse-Edit',
            component: () => import('@/modules/wms-manage/warehouse/edit.vue'),
            meta: {
                parent: '/modules/wms/manage/warehouse',
            }
        },
        {
            path: 'warehousing',
            name: 'Wms-Manage-Warehousing',
            component: () => import('@/modules/wms-manage/warehousing/index.vue'),
            meta: {
                pageTitle: '入库管理',
            }
        },
        {
            path: 'warehousing/edit',
            name: 'Wms-Manage-Warehousing-Edit',
            component: () => import('@/modules/wms-manage/warehousing/edit.vue'),
            meta: {
                parent: '/modules/wms/manage/warehousing',
            }
        },
        {
            path: 'delivery',
            name: 'Wms-Manage-Delivery',
            component: () => import('@/modules/wms-manage/delivery/index.vue'),
            meta: {
                pageTitle: '出库管理',
            }
        },
        {
            path: 'delivery/edit',
            name: 'Wms-Manage-delivery-Edit',
            component: () => import('@/modules/wms-manage/delivery/edit.vue'),
            meta: {
                parent: '/modules/wms/manage/delivery',
            }
        },
        {
            path: 'inventory',
            name: 'Wms-Manage-Inventory',
            component: () => import('@/modules/wms-manage/inventory/index.vue'),
            meta: {
                pageTitle: '库存盘点',
            }
        },
        {
            path: 'inventory/edit',
            name: 'Wms-Manage-inventory-Edit',
            component: () => import('@/modules/wms-manage/inventory/edit.vue')
        },

        {
            path: 'stock',
            name: 'Wms-Manage-Stock',
            component: () => import('@/modules/wms-manage/stock/index.vue'),
            meta: {
                pageTitle: '库存查询',
            }
        },
        {
            path: 'transfer',
            name: 'Wms-Manage-Transfer',
            component: () => import('@/modules/wms-manage/transfer/index.vue'),
            meta: {
                pageTitle: '库存调拨',
            }
        },
        {
            path: 'transfer/edit',
            name: 'Wms-Manage-Transfer-Edit',
            component: () => import('@/modules/wms-manage/transfer/edit.vue'),
            meta: {
                parent: '/modules/wms/manage/transfer',
            }
        },
        {
            path: 'transfer/detail',
            name: 'Wms-Manage-Transfer-Detail',
            component: () => import('@/modules/wms-manage/transfer/edit.vue'),
            meta: {
                parent: '/modules/wms/manage/transfer',
            }
        },
    ],

};
export const WmsManageRuter = route;
